import type { OctFlash2026Variant } from '../constants/oct-flash-2026';

export const OCT_FLASH_2026_G1_PROMOTION_ID = 'oct50';
export const OCT_FLASH_2026_G2_PROMOTION_ID = 'oct10';

export type OctFlash2026MarketTier = 'full' | 'low';

export function getOctFlash2026MarketTier(variant: OctFlash2026Variant): OctFlash2026MarketTier {
  return variant === 'g2' ? 'low' : 'full';
}

export function getOctFlash2026Variant(promotionId: string | null | undefined): OctFlash2026Variant | null {
  if (promotionId === OCT_FLASH_2026_G1_PROMOTION_ID) {
    return 'g1';
  }
  if (promotionId === OCT_FLASH_2026_G2_PROMOTION_ID) {
    return 'g2';
  }
  return null;
}

export function getOctFlash2026SlideKey(variant: OctFlash2026Variant): string {
  return `oct-flash-2026-${variant}`;
}

export function resolveOctFlash2026Variant(
  forcedPromotionId: string | null | undefined,
  promotionId: string | null | undefined
): OctFlash2026Variant | null {
  return getOctFlash2026Variant(forcedPromotionId) ?? getOctFlash2026Variant(promotionId);
}
